import { cn } from '@/lib/utils';

/**
 * Placeholder con gradient brand cuando no hay imagen/cover real.
 * Aspecto adaptable: aspect-video, aspect-square, etc.
 */
interface Props {
  label?: string;
  className?: string;
  shape?: 'rect' | 'circle';
  /** Iniciales para avatars (placeholder circular) */
  initials?: string;
}

export function BrandedPlaceholder({ label, className, shape = 'rect', initials }: Props) {
  return (
    <div
      className={cn(
        'flex items-center justify-center bg-gradient-to-br from-brand-primary via-brand-accent to-brand-energy/70 text-white relative overflow-hidden',
        shape === 'circle' ? 'rounded-full' : 'rounded-lg',
        className
      )}
    >
      {/* Patrón decorativo sutil */}
      <div className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.3) 0%, transparent 50%), radial-gradient(circle at 70% 70%, rgba(0,0,0,0.2) 0%, transparent 50%)',
        }}
      />
      <div className="relative z-10 text-center px-3">
        {initials ? (
          <span className="text-2xl font-bold tracking-tight">{initials}</span>
        ) : label ? (
          <span className="text-sm font-medium opacity-90">{label}</span>
        ) : (
          <svg className="h-12 w-12 opacity-50" fill="currentColor" viewBox="0 0 20 20">
            <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" />
            <path fillRule="evenodd" d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" clipRule="evenodd" />
          </svg>
        )}
      </div>
    </div>
  );
}
